import React, {useState} from 'react';
import { connect } from 'react-redux';
import {getBirthdateErrorMessage, getBirthdateStatus, getBirthDay, getBirthMonth, getBirthYear,
    getIsFormValidating, getIsLoadingDateOfBirthCheck,
} from "../../selectors";
import {changeBirthDate, validateForm} from "../../reducers";
import {calculateAge, getYears, isValidDate, showLoader} from "../../utils";

const stateToProps = state => ({
    dateStatus: getBirthdateStatus(state),
    isLoadingDateOfBirthCheck: getIsLoadingDateOfBirthCheck(state),
    day: getBirthDay(state),
    month: getBirthMonth(state),
    year: getBirthYear(state),
    isFormValidating: getIsFormValidating(state),
    dateErrorMessage: getBirthdateErrorMessage(state),
});

const actionsToProps = dispatch => ({
    changeBirthDate: payload => dispatch(changeBirthDate(payload)),
    validateForm: payload => dispatch(validateForm(payload)),
});

const BirthDate = props => {
    const [dayOpen, setDayOpen ] = useState(false);
    const [monthOpen, setMonthOpen ] = useState(false);
    const [yearOpen, setYearOpen ] = useState(false);

    const checkDate = (day, month, year) => {
        if (day === '-' || month === '-' || year === '-') {
            props.changeBirthDate({ dateStatus: 'none' });
            return false;
        }

        if (isValidDate(day, month, year)) {
            const age = calculateAge(day, month, year);

            if (age < 18) {
                props.changeBirthDate({
                    dateStatus: 'error',
                    dateErrorMessage: 'Must be at least 18 years old',
                });

                return false;
            } else {
                props.changeBirthDate({ dateStatus: 'success' });
                return true;
            }
        } else {
            props.changeBirthDate({
                dateStatus: 'error',
                dateErrorMessage: `Invalid date`,
            });
        }
    };

    const closeDropDown = (e) => {
        const target = e.target;

        if (target.id != null) {
            const targetId = target.id;

            if (targetId === 'dayOpen') {
                setDayOpen(false);
            } else if (targetId === 'monthOpen') {
                setMonthOpen(false);
            } else if (targetId === 'yearOpen') {
                setYearOpen(false);
            }
        }
    }

    let currentDate = new Date(2000, 1,1);
    let months = Array.from(new Array(12), (_, monthIdx) => {
        currentDate.setMonth(monthIdx);
        return {
            index: monthIdx + 1,
            label: currentDate.toLocaleString("en-US", {month: "long"})
        }
    });

    let selectedMonthLabel = months.find(item => item.index === props.month);

    return (
        <div className={`form-row ${props.dateStatus}`}>
            <label className="form-label" htmlFor="dayOpen">
                {props.isLoadingDateOfBirthCheck && showLoader()}
                Date of birth <span className="asterisk">*</span>
            </label>

            <div className="dd-menu-group wrap">
                <div tabIndex="1" id="dayOpen" onBlur={closeDropDown} className={dayOpen === true ? 'dd-menu day dd-menu-open' : 'dd-menu day'}>
                    <span className="dd-menu--trigger" onClick={() => setDayOpen(!dayOpen)} id="birthDay">
                        {props.day}
                    </span>

                    <span className="dd-menu--caret" />

                    <ul className="dd-menu__list" disabled={props.isFormValidating}>
                        {Array.from({length: 31}, (_, day) => day + 1).map(el => (
                            <li key={`dd-days-${el}`} className="dd-menu__list-item">
                                <a className="dd-menu__list-link"
                                   onClick={() => {
                                       props.changeBirthDate({ day: el });
                                       setDayOpen(false);
                                       const dateValid = checkDate(el, props.month, props.year);
                                       if (dateValid) {
                                           props.validateForm({ updatedField: 'birthdate' });
                                       }
                                   }}
                                >
                                    {el}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>

                <div tabIndex="2" id="monthOpen" onBlur={closeDropDown} className={monthOpen === true ? 'dd-menu month dd-menu-open' : 'dd-menu month'}>
                    <span className="dd-menu--trigger" onClick={() => setMonthOpen(!monthOpen)} id="birthMonth">
                        {selectedMonthLabel != null ? selectedMonthLabel.label : '-'}
                    </span>

                    <span className="dd-menu--caret" />

                    <ul className="dd-menu__list" disabled={props.isFormValidating}>
                        {months.map(month => (
                            <li key={`dd-months-${month.index}`} className="dd-menu__list-item">
                                <a className="dd-menu__list-link"
                                   onClick={() => {
                                       props.changeBirthDate({ month: month.index });
                                       setMonthOpen(false);
                                       const dateValid = checkDate(props.day, month.index, props.year);
                                       if (dateValid) {
                                           props.validateForm({ updatedField: 'birthdate' });
                                       }
                                   }}
                                >
                                    {month.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>

                <div tabIndex="3" id="yearOpen" onBlur={closeDropDown} className={yearOpen === true ? 'dd-menu year dd-menu-open' : 'dd-menu year'}>
                    <span className="dd-menu--trigger" onClick={() => setYearOpen(!yearOpen)} id="birthYear">
                        {props.year}
                    </span>

                    <span className="dd-menu--caret" />

                    <ul className="dd-menu__list" disabled={props.isFormValidating}>
                        {getYears().map(el => (
                            <li key={`dd-years-${el}`} className="dd-menu__list-item">
                                <a className="dd-menu__list-link"
                                   onClick={() => {
                                       props.changeBirthDate({ year: el });
                                       setYearOpen(false);
                                       const dateValid = checkDate(props.day, props.month, el);
                                       if (dateValid) {
                                           props.validateForm({ updatedField: 'birthdate' });
                                       }
                                   }}
                                >
                                    {el}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <p className="callout error p10 txt-l">
                {props.dateErrorMessage || 'Invalid date selected'}
            </p>
            <i className="form-status" />
        </div>
    );
}

export default connect(
    stateToProps,
    actionsToProps
)(BirthDate);
